import { render, staticRenderFns } from "./CancelGroupClassConfirmationDialog.vue?vue&type=template&id=c36db5ba"
import script from "./CancelGroupClassConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./CancelGroupClassConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports